var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modal",
      staticClass: "incomplete-full-screen-modal",
      attrs: {
        id: "annonce-incomplete-modal",
        "header-class": "incomplete-modal-header",
        centered: "",
        "no-close-on-esc": "",
        "no-close-on-backdrop": ""
      },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function(ref) {
            var close = ref.close
            return [
              _c(
                "div",
                { staticClass: "incomplete-modal-header-content step4 w-100" },
                [
                  _c("img", {
                    staticClass: "incomplete-modal-img",
                    attrs: {
                      src: require("@/assets/images/b122/img-watcher-right.png")
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "incomplete-container h-100" }, [
                    _c(
                      "h1",
                      {
                        staticClass:
                          "page-title mt-4 ml-4 incomplete-modal-subtitle"
                      },
                      [_vm._v(_vm._s(_vm.$t("annonce.incomplete.modal.title")))]
                    )
                  ])
                ]
              )
            ]
          }
        },
        {
          key: "modal-footer",
          fn: function(ref) {
            var ok = ref.ok
            var cancel = ref.cancel
            var hide = ref.hide
            return [
              _c(
                "div",
                { staticClass: "w-100 d-flex" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "w-100 mr-2",
                      attrs: { variant: "secondary", disabled: _vm.isLoading },
                      on: {
                        click: function($event) {
                          return _vm.handleOk($event)
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-center" },
                        [
                          _c(
                            "span",
                            { staticClass: "align-self-center mt-small-px" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("annonce.incomplete.modal.publish")
                                )
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "w-100",
                      attrs: { variant: "primary", disabled: _vm.isLoading },
                      on: { click: _vm.handleCancel }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-center" },
                        [
                          _c(
                            "span",
                            { staticClass: "align-self-center mt-small-px" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("annonce.incomplete.modal.complete")
                                )
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            ]
          }
        }
      ])
    },
    [
      _vm._v(" "),
      _c(
        "div",
        [
          _c("p", {
            staticClass: "modal-annonce-text mt-2",
            domProps: {
              innerHTML: _vm._s(_vm.$t("annonce.incomplete.modal.text"))
            }
          }),
          _vm._v(" "),
          _c(
            "b-form-checkbox",
            {
              staticClass: "mt-3",
              attrs: { id: "needsReminderNotification" },
              model: {
                value: _vm.annonce.needsReminderNotification,
                callback: function($$v) {
                  _vm.$set(_vm.annonce, "needsReminderNotification", $$v)
                },
                expression: "annonce.needsReminderNotification"
              }
            },
            [
              _c("span", { staticClass: "custom-span-checkbox" }, [
                _vm._v(_vm._s(_vm.$t("annonce.incomplete.modal.notif")))
              ])
            ]
          ),
          _vm._v(" "),
          _c("p", {
            staticClass: "modal-annonce-text-offline",
            domProps: {
              innerHTML: _vm._s(_vm.$t("annonce.incomplete.modal.wait.text"))
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4941af98", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4941af98","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/annonce/AnnonceIncompleteModal.vue
// module id = W35C
// module chunks = 0